export const UNIT_DIMENSIONS = {
    JOD: { JOD: 1 },
    km: { km: 1 },
    L: { L: 1 },
    days: { day: 1 },
    years: { year: 1 },
    fraction: {},
    count: {},
    flag: {},
    'JOD/day': { JOD: 1, day: -1 },
    'JOD/L': { JOD: 1, L: -1 },
    'km/year': { km: 1, year: -1 },
};
export const dimensionForUnit = (unit) => UNIT_DIMENSIONS[unit];
/**
 * The narrowest unit name that has a given dimension, used to explain a mismatch in the admin's own
 * vocabulary ("this reads as km, but the equation is declared JOD").
 */
export const unitNameForDimension = (dimension) => {
    const entries = Object.entries(UNIT_DIMENSIONS);
    const match = entries.find(([, candidate]) => {
        const bases = new Set([...Object.keys(candidate), ...Object.keys(dimension)]);
        return [...bases].every((base) => {
            const key = base;
            return (candidate[key] ?? 0) === (dimension[key] ?? 0);
        });
    });
    return match ? match[0] : null;
};
//# sourceMappingURL=units.js.map